import * as React from 'react';
import { Nav } from '~/ab-common/src';
import { Footer } from '../Footer';

// eslint-disable-next-line react/prop-types
export function Layout({ fullscreen, children }) {
  return (
    <>
      {fullscreen || <Nav />}
      {children}
      {fullscreen || <Footer />}
    </>
  );
}
